const Rolesmodule = [
  {
    id: 1,
    module: "Staff",
    view: 0,
    add: 0,
    edit: 0,
    delete: 0,
    isAdd: true,
    isEdit: true,
    isDelete: true,
  },
  {
    id: 2,
    module: "Lead",
    view: 0,
    add: 0,
    edit: 0,
    delete: 0,
    isAdd: true,
    isEdit: true,
    isDelete: true,
  },
  {
    id: 3,
    module: "Marketing - Opportunity",
    view: 0,
    add: 0,
    edit: 0,
    delete: 0,
    isAdd: true,
    isEdit: true,
    isDelete: true,
  },
  {
    id: 4,
    module: "Marketing - Cold Calling",
    view: 0,
    add: 0,
    edit: 0,
    delete: 0,
    isAdd: true,
    isEdit: true,
    isDelete: true,
  },
  {
    id: 5,
    module: "Payroll - Salary",
    view: 0,
    add: 0,
    edit: 0,
    delete: 0,
    isAdd: true,
    isEdit: true,
    isDelete: true,
  },
  {
    id: 6,
    module: "Payroll - Slip",
    view: 0,
    add: 0,
    edit: 0,
    delete: 0,
    isAdd: true,
    isEdit: true,
    isDelete: true,
  },
  {
    id: 7,
    module: "Location Tracking",
    view: 0,
    add: 0,
    edit: 0,
    delete: 0,
    isAdd: true,
    isEdit: true,
    isDelete: true,
  },
  {
    id: 8,
    module: "Leave Management - Leave",
    view: 0,
    add: 0,
    edit: 0,
    delete: 0,
    isAdd: true,
    isEdit: true,
    isDelete: true,
  },
  {
    id: 9,
    module: "Leave Management - Holiday",
    view: 0,
    add: 0,
    edit: 0,
    delete: 0,
    isAdd: true,
    isEdit: true,
    isDelete: true,
  },
  {
    id: 10,
    module: "Settings - Roles",
    view: 0,
    add: 0,
    edit: 0,
    delete: 0,
    isAdd: true,
    isEdit: true,
    isDelete: true,
  },
]

export default Rolesmodule
